import React, { useState } from 'react'

import styles from '../Signup.module.css'

import { thirteenYearsAgoDateField, todayDateField } from 'Utils/date'

import { TextField, EmailField, PasswordField, DateField } from 'components/Fields'
import Heading from 'components/Heading'
import Button from 'components/Button'
import { isofetch } from 'Services/Fetch'
import { debounce } from 'debounce'

const ChooseSignup = ({ setValue, handleSubmit, isSubmitting, formField, formErrorMessage }) => {
  const { firstName, lastName, email, password, dateOfBirth } = formField

  const submit = () => {
    setValue('step', 'account')
    handleSubmit()
  }

  const email_exists = async () => {
    const exists = debounce(async (email) => {
      const response = await isofetch('/api/account/exists', 'POST', { email })

      if (response?.exists === true) {
        return false
      }
    }, 500)

    // console.log({ exists })
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>
        Create Your CNC Expert Account
      </Heading>
      <div className={styles['create-account-wrapper']}>
        <div className={styles['signup-fields']}>
          <div className={styles['signup-field-name']}>
            <TextField
              name={firstName.name}
              label={firstName.label}
              className={styles['signup-input']}
              validations={firstName.validations}
            />

            <TextField
              name={lastName.name}
              label={lastName.label}
              className={styles['signup-input']}
              validations={lastName.validations}
            />
          </div>

          <div className={styles['signup-field-date']}>
            <DateField
              name={dateOfBirth.name}
              label={dateOfBirth.label}
              className={styles['signup-input']}
              validations={dateOfBirth.validations}
            />
          </div>

          <div className={styles['signup-field-email']}>
            <EmailField
              name={email.name}
              label={email.label}
              validations={{
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'invalid email address',
                },
                validate: {
                  email_exists: async (email) => {
                    const response = await isofetch('/api/account/exists', 'POST', { email })

                    if (response?.exists === true) {
                      return false
                    }
                  },
                },
              }}
              className={styles['signup-input']}
              autoComplete="username"
            />
          </div>

          <div className={styles['signup-field-password']}>
            <PasswordField
              name={password.name}
              label={password.label}
              validations={password.validations}
              className={styles['signup-input']}
            />
          </div>
        </div>

        <div className={styles['form-footer']}>
          <Button onClick={submit} buttonElement primary centered disabled={isSubmitting} spinner={isSubmitting}>
            Next
          </Button>

          {formErrorMessage && (
            <div className={styles['error']} dangerouslySetInnerHTML={{ __html: formErrorMessage }} />
          )}
        </div>
      </div>
    </div>
  )
}

export default ChooseSignup
